import { Component, OnInit } from '@angular/core';
import { AppointmentForEmp } from 'src/app/model/Security/AppointmentForEmp';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/common/constant';
import { AppointmentForEmpService } from 'src/app/service/Security/appointment-for-emp.service';
import { ToastService } from 'src/app/service/toast.service';
import { MainContainerService } from 'src/app/service/main-container.service';
import { CommonService } from 'src/app/service/Security/common.service';
import { LocalStorageService } from 'src/app/common/LocalStorageService';


@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.css']
})
export class PermissionComponent implements OnInit {

  public viewDataAvail: boolean=false;
  public permissionYesNo:string[];
  appointmentForEmpList: AppointmentForEmp[];
  appointmentForEmpSubcription: Subscription;
  
  noOfDaysAllowed: any;
  ActiveTab: number;
  maxAllowDate: Date = new Date();
 viewatableColumns: string[] = ['visitor_name','visitor_company','visitor_mobile_no','address','appointment_type','purpose','schedule_date_from', 'permission'];
 constructor(private commonService : CommonService,
   private constant: Constant,
   private appointmentForEmpService: AppointmentForEmpService,
    private toastService: ToastService,
    private mainContainerService: MainContainerService,
    public persistenceService: LocalStorageService
    ) { }
  ngOnInit() {
    this.permissionYesNo = this.constant.yesNoList;
    this.getAppointmentForEmpList();
  }
  getAppointmentForEmpList() {
    this.appointmentForEmpSubcription = this.commonService.getAppointmentListForEmpById(1).subscribe((data) => {
      this.appointmentForEmpList = data;
      if (this.appointmentForEmpList.length === 0) {
        this.viewDataAvail = false;
      }
      else
        this.viewDataAvail = true;
    
    });
    
  }
  tabClicked(event:any)
  {
    
  }
}
